import styles from "./styles.module.scss";
import React, { FunctionComponent } from "react";
import { Card, CardActionArea, Stack, useTheme } from "@mui/material";
import { ISellValue } from "../../../../hooks/sellValues";
import { useCurrencyFormatter } from "../../../../hooks/currencyFormatter";
import { useUserProfile } from "../../../../hooks/session";
import { Icon, IconType } from "../../../../icons";

export const SellValueCard: FunctionComponent<ISellValueCardProps> = ({
  sellValue,
  selected,
  onClick,
  onContextMenu
}) => {
  const theme = useTheme();
  const currencyFormatter = useCurrencyFormatter();
  const [currentUserProfile] = useUserProfile.useState();
  return (
    <Card className={styles.container} sx={{ height: 80 }} elevation={5}>
      <CardActionArea
        className={styles.cardArea}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "row"
        }}
        style={{
          borderColor: theme.palette.colors?.highlightBorder,
          borderWidth: 4,
          borderStyle: selected ? "double" : "none"
        }}
        onClick={onClick}
        onContextMenu={onContextMenu}
      >
        <Stack alignItems={"center"}>
          <Card className={styles.defaultIcon}>
            <Icon type={IconType.PriceChange} />
          </Card>
          <Card style={{ marginTop: -2, backgroundColor: theme.palette.colors.buttonBackground }}>
            <p className={styles.inactiveCard}>{`${currencyFormatter.format(
              sellValue.dollars,
              currentUserProfile,
              false,
              2,
              "USD"
            )}`}</p>
          </Card>
        </Stack>
        <Stack className={styles.rightContainer}>
          <p className={styles.name}>{sellValue.group}</p>
          <p className={styles.profile}>{sellValue.description}</p>
        </Stack>
      </CardActionArea>
    </Card>
  );
};

export interface ISellValueCardProps {
  sellValue: ISellValue;
  selected?: boolean;
  onClick: () => void;
  onContextMenu: (event: React.MouseEvent) => void;
}
